enum TOOLTIP {
  MARCAR_COMO_EMAIL_NAO_LIDO = "Marcar como não lido",
  MARCAR_COMO_EMAIL_LIDO = "Marcar como lido",
}

export default TOOLTIP;
